export default __webpack_public_path__ + "images/0x60781c2586d68229fde47564546784ab3faca982.png";